module.exports = __webpack_public_path__ + "static/media/logo_login.dab65a85.svg";